"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeveloperIcon = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("@emotion/react");
const DeveloperIcon = (_a) => {
    var { color } = _a, props = __rest(_a, ["color"]);
    const theme = (0, react_1.useTheme)();
    return ((0, jsx_runtime_1.jsx)("svg", Object.assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none" }, props, { children: (0, jsx_runtime_1.jsx)("path", { d: "M8.839 15.632v-2.23L5.873 11.84l-2.075-1.103v-.092L5.873 9.54l2.966-1.563v-2.23L2 9.724v1.931l6.839 3.977zM9.54 22h1.2l3.58-20h-1.199l-3.58 20zM15.161 15.632L22 11.655v-1.93l-6.839-3.978v2.23l2.966 1.563 2.075 1.104v.092l-2.075 1.103-2.966 1.563v2.23z", fill: color !== null && color !== void 0 ? color : theme.colors.grey90 }) })));
};
exports.DeveloperIcon = DeveloperIcon;
//# sourceMappingURL=developer_icon.js.map